import * as React from "react";
import { observer } from "mobx-react";
import { Promise } from 'es6-promise';
import { InputFile } from "../Shared";
import * as Utilities from "../Utilities";

import { Strings } from "../Stores/StringsStore";

export interface IInputFileComponentProps {
	model: InputFile;
	onChange?: () => void;
	testId?: string;
	testName?: string;
}

@observer
export class InputFileComponent extends React.Component<IInputFileComponentProps, {}> {

	private handleFileChanged = () => {

		if (this.refs.input.files.length == 1) {
			this.upload(this.refs.input.files[0]).then(guid => {
				this.props.model.value = guid;
				this.props.model.previewUrl = "/upload/" + guid;
			}).catch(error => {

			});

		}
	}

	click = () => {	
		this.refs.input.click();
	}

	refs: {
		[key: string]: HTMLElement;
		input: HTMLInputElement;
	}

	upload(file: File) {

		return new Promise<string>((resolve: (result: string) => void, reject: (error: string) => void) => {
			let guid = Utilities.newGuid();
			var xhr = new XMLHttpRequest();
			xhr.open('POST', '/upload', true);
			xhr.setRequestHeader("Content-Type", file.type);
			xhr.setRequestHeader("x-guid", guid);
			xhr.setRequestHeader("x-filename", file.name.replace(/[^\x00-\x7F]/g, ""));
			xhr.setRequestHeader("x-start", "0");
			xhr.setRequestHeader("x-end", file.size.toString());
			xhr.setRequestHeader("x-total", file.size.toString());

			xhr.onerror = (e) => {
				reject("upload failed");
			};

			xhr.onloadend = (e) => {
				resolve(guid);
			}

			xhr.send(file);
		});
	}


	render() {
		let label = this.props.model.label ? <span>{this.props.model.label}</span> : null;

		let message = this.props.model.validationMessage ? <span className="is--validation-note">{this.props.model.validationMessage}</span> : null;

		let image = this.props.model.previewUrl ? <span className="imageupload-preview__thumb-image"><img src={this.props.model.previewUrl} alt="" /></span> : <span className="imageupload-preview__thumb-message">{Strings.general.clickToAddImageText}</span>;

		return <div>
			{label}
			<input type="file"
				ref="input"
				onChange={this.handleFileChanged}
				accept={this.props.model.mimeTypes}
				disabled={this.props.model.isReadOnly}
				data-test-id={this.props.testId}
				data-test-name={this.props.testName} />
			<div className={!this.props.model.isValid ? "imageupload-preview__thumb is--input-invalid" : "imageupload-preview__thumb"}>
				{image}
			</div>
			{message}
		</div>;
	}
}

